import React from 'react';
import { Alert, Box } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

/**
 * Displays one alert per limit rule violation inside a Buy/Sell modal.
 * Renders nothing when there are no messages.
 *
 * @param {{ messages: string[] }} props
 */
const LimitBanner = ({ messages }) => {
    if (!messages || messages.length === 0) return null;

    return (
        <Box className="flex flex-col gap-2">
            {messages.map((message, index) => (
                <Alert
                    key={index}
                    severity="error"
                    icon={<WarningAmberIcon />}
                    sx={{ fontSize: '0.82rem', alignItems: 'center' }}
                >
                    {message}
                </Alert>
            ))}
        </Box>
    );
};

export default LimitBanner;
